<app-ssc-shell title="Batch / API / CAT Integration">
  <section class="batch-page">
    <div class="ssc-grid g3 batch-summary">
      <div class="ssc-card">
        <div class="ssc-muted">{{ finalizedFilesLabel }}</div>
        <div class="ssc-kpi">{{ selectedFilesCount }}</div>
      </div>
      <div class="ssc-card">
        <div class="ssc-muted">Target Languages</div>
        <div class="ssc-kpi">{{ targetLanguageCount }}</div>
      </div>
      <div class="ssc-card">
        <div class="ssc-muted">Total Estimated Ready</div>
        <div class="ssc-kpi kpi-sm">{{ estimatedReadyAt }}</div>
      </div>
    </div>

    <div class="batch-layout">
      <section class="ssc-card batch-upload-card">
        <div class="batch-job-head">
          <div>
            <h3 class="ssc-section-title">Bulk Translation Job</h3>
            <p class="ssc-muted">Choose Excel files or image files, fill language details, finalize them, then run the batch.</p>
            
          </div>
          <a class="batch-template-link" href="javascript:void(0)" (click)="$event.stopPropagation(); downloadTemplate()">Download Template</a>
        </div>

        <div class="batch-job-content">
          <div class="batch-job-step">
            @if (pendingConfigs.length) {
              <div class="batch-config-list batch-step-section">
                <h3 class="ssc-section-title batch-column-title">File Details To Finalize</h3>
                @for (config of pendingConfigs; track config.id) {
                  <div class="batch-config-card">
                    <div class="batch-config-head">
                      <div>
                        <strong class="batch-excel-name" [title]="config.name">{{ excelNamePreview(config.name) }}</strong>
                      </div>
                      <div class="batch-row-actions">
                        <button class="ssc-btn primary tiny" type="button" [disabled]="!isConfigReady(config)" (click)="finalizeFileConfig(config)">
                          Finalize
                        </button>
                        <button class="ssc-btn icon tiny" type="button" title="Remove" aria-label="Remove" (click)="removePendingFile(config)">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>

                    <div class="batch-config-grid">
                      <fieldset class="ssc-field batch-legend-field">
                        <legend>Source Language</legend>
                        <select class="batch-input-control" [(ngModel)]="config.sourceLanguage" (ngModelChange)="markConfigDirty(config)">
                          <option [ngValue]="''">Use Excel source language</option>
                          @for (language of languages; track language.language_code) {
                            <option [ngValue]="language.language_name">{{ language.language_name }}</option>
                          }
                        </select>
                      </fieldset>

                      <fieldset class="ssc-field batch-legend-field">
                        <legend>Subject</legend>
                        <select class="batch-input-control" [(ngModel)]="config.subject" (ngModelChange)="markConfigDirty(config)">
                          <option [ngValue]="''">Use Excel subject</option>
                          @for (subject of subjects; track subject.subject_name) {
                            <option [ngValue]="subject.subject_name">{{ subject.subject_name }}</option>
                          }
                        </select>
                      </fieldset>

                      <fieldset class="ssc-field batch-legend-field batch-target-field">
                        <legend>Target Languages</legend>
                        <div class="batch-autocomplete">
                          <div class="batch-selected-languages batch-input-control">
                            @for (language of config.targetLanguages; track language) {
                              <button type="button" (click)="removeTargetLanguage(config, language)">{{ language }} x</button>
                            }
                            <input
                              type="text"
                              [(ngModel)]="config.targetLanguageSearch"
                              (focus)="config.targetLanguagePanelOpen = true"
                              (blur)="closeTargetLanguagePanel(config)"
                              [placeholder]="config.targetLanguages.length ? 'Search target languages' : 'Use Excel target languages'"
                              autocomplete="off"
                            >
                          </div>
                          @if (config.targetLanguagePanelOpen) {
                            <div class="batch-autocomplete__panel">
                              @if (!filteredTargetLanguages(config).length) {
                                <button type="button" disabled>No language found</button>
                              }
                              @for (language of filteredTargetLanguages(config); track language.language_code) {
                                <button type="button" (mousedown)="addTargetLanguage(config, language)">
                                  {{ language.language_name }} @if (language.native_name) { - {{ language.native_name }} }
                                </button>
                              }
                            </div>
                          }
                        </div>
                      </fieldset>
                    </div>

                    <div class="batch-actions finalize-actions">
                      <span class="ssc-muted">After finalizing, choose another Excel if needed. <span>Estimated ready: {{ config.estimatedReadyAt }}</span> </span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="batch-section-tools batch-step-section">
                <h3 class="ssc-section-title batch-column-title">Choose Excel or image files</h3>
                <label class="batch-dropzone">
                  <input type="file" multiple accept=".xlsx,image/png,image/jpeg,image/webp" (change)="onFilesSelected($event)">
                  <strong>Select files</strong>
                  <span>Use Excel files or multiple images in one run</span>
                </label>
              </div>
            }
          </div>

          <div class="batch-config-list batch-finalized-panel">
            <h3 class="ssc-section-title">{{ finalizedFilesLabel }}</h3>
            <div class="batch-finalized-scroll">
              @if (fileConfigs.length) {
                @for (config of fileConfigs; track config.id) {
                  <div class="batch-finalized-row">
                    <div>
                      <strong class="batch-excel-name" [title]="config.name">{{ excelNamePreview(config.name) }}</strong>
                      <em>Estimated ready: {{ config.estimatedReadyAt }}</em>
                    </div>
                    @if (!isProcessing) {
                      <div class="batch-row-actions">
                        <button class="ssc-btn tiny" type="button" (click)="editFinalizedFile(config)">Edit</button>
                        <button class="ssc-btn icon tiny" type="button" title="Remove" aria-label="Remove" (click)="removeFinalizedFile(config)">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    }
                  </div>
                }
              } @else {
                <div class="batch-empty-state">No finalized file yet.</div>
              }
            </div>
          </div>
        </div>

        <div class="batch-actions batch-run-actions">
          <span class="ssc-muted">Total conversion ready around {{ estimatedReadyAt }}</span>
          <button class="ssc-btn primary" type="button" [disabled]="!canRunBatch" (click)="runBatch()">
            {{ isProcessing ? 'Processing...' : 'Run Batch' }}
          </button>
        </div>

        @if (errorMessage) {
          <div class="batch-error mt-3">{{ errorMessage }}</div>
        }
      </section>

      <aside class="ssc-card batch-status-card">
        <h3 class="ssc-section-title">Processing Status  </h3>
        <div class="batch-status-scroll">
          @if (!fileStatuses.length) {
            <div class="ssc-muted">No finalized files.</div>
          }
          @for (file of fileStatuses; track file.id) {
            <div class="batch-file-status" [class.completed]="file.status === 'Ready'">
              <div>
                <strong>{{ file.name }}</strong>
                <span>{{ file.status }} - {{ file.done }} / {{ file.total || '?' }} questions</span>
                <span>{{ file.completedBatches }} / {{ file.totalBatches || '?' }} batches completed</span>
                @if (file.currentBatchLabel) {
                  <span class="batch-current">{{ file.currentBatchLabel }}</span>
                }
              </div>
              <div class="ssc-progress"><span [style.width.%]="progressPercent(file)"></span></div>
            </div>
          }
        </div>
      </aside>
    </div>

    @if (fileConfigs.length) {
      <section class="ssc-card batch-results">
        <div class="batch-section-head">
          <div>
            <h3 class="ssc-section-title">Excel Queue</h3>
            <p class="ssc-muted">Completed files can be downloaded or viewed from here.</p>
          </div>
        </div>

        @for (config of fileConfigs; track config.id) {
          <div class="batch-result-file">
            <div class="batch-result-head">
              <div>
                <strong>{{ config.name }}</strong>
                @if (resultForConfig(config); as result) {
                  <span>Ready - {{ result.done_questions }} / {{ result.total_questions }} questions completed</span>
                } @else {
                  <span>{{ isProcessing ? 'Waiting for conversion' : 'Ready to run' }} - estimated {{ config.estimatedReadyAt }}</span>
                }
              </div>
              <div class="batch-result-actions">
                @if (resultForConfig(config); as result) {
                  <button class="ssc-btn" type="button" (click)="downloadResultWorkbook(result)">Download Excel</button>
                  <button class="ssc-btn" type="button" [disabled]="reviewSaving" (click)="approveAllTranslations(result)">Approve All</button>
                  @if (expandedFileName === result.file_name) {
                    <button class="ssc-btn primary" type="button" (click)="hideFileDetails(result)">Hide</button>
                  } @else {
                    <button class="ssc-btn primary" type="button" (click)="viewFileDetails(result)">View</button>
                  }
                }
              </div>
            </div>

            @if (resultForConfig(config); as result) {
              @if (expandedFileName === result.file_name) {
                <div class="batch-question-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Row</th>
                        <th>Subject</th>
                        <th>Question</th>
                        <th>Status</th>
                        <th>Review</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (question of result.questions; track question.row_number) {
                        <tr [class.active]="selectedQuestion?.file?.file_name === result.file_name && selectedQuestion?.question?.row_number === question.row_number">
                          <td>{{ question.row_number }}</td>
                          <td>{{ question.subject || '-' }}</td>
                          <td>{{ questionPreview(questionDisplayText(question)) }}</td>
                          <td>{{ question.status }}</td>
                          <td>
                            <span class="batch-review-pill" [ngClass]="reviewStatusClass(question.translations[0]?.status || 'Draft')">
                              {{ question.translations[0]?.status || 'Draft' }}
                            </span>
                          </td>
                          <td><button class="ssc-btn tiny" type="button" (click)="selectQuestion(result, question)">Other Details</button></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            }
          </div>
        }
      </section>
    }

  </section>

  @if (selectedQuestion) {
    <div class="batch-modal-backdrop" (click)="closeQuestionDetails()">
      <section class="batch-modal" (click)="$event.stopPropagation()">
        <header class="batch-modal-head">
          <div>
            <h3>Question Details</h3>
            <span>{{ selectedQuestion.file.file_name }} - Row {{ selectedQuestion.question.row_number }}</span>
          </div>
          <button class="ssc-btn tiny" type="button" (click)="closeQuestionDetails()">Close</button>
        </header>

        <div class="batch-modal-meta">
          <div><span>Source</span><strong>{{ selectedQuestion.question.source_language || '-' }}</strong></div>
          <div><span>Target</span><strong>{{ detailTargetLanguages(selectedQuestion.question) }}</strong></div>
          <div><span>Subject</span><strong>{{ selectedQuestion.question.subject || '-' }}</strong></div>
          <div><span>Status</span><strong>{{ selectedQuestion.question.status }}</strong></div>
          @if (activeTranslation(selectedQuestion.question); as activeMeta) {
            <div><span>Review</span><strong>{{ activeMeta.status || 'Draft' }}</strong></div>
          }
        </div>

        <div class="batch-modal-body">
          <div class="batch-modal-question">
            <h4>Original Question</h4>
            <div class="batch-question-text">{{ questionDisplayText(selectedQuestion.question) }}</div>
          </div>

          <div class="batch-modal-translations">
            <div class="batch-language-tabs" aria-label="Translation languages">
              @for (translation of selectedQuestion.question.translations; track translation.target_language) {
                <button
                  type="button"
                  [class.active]="translation.target_language === selectedTranslationTarget"
                  (click)="selectTranslationTarget(translation.target_language)"
                >
                  {{ translation.target_language }}
                </button>
              }
            </div>

            @if (activeTranslation(selectedQuestion.question); as translation) {
              <div class="batch-translation-panel active">
                <div class="batch-language-title">{{ translation.target_language }} Translation</div>
                <textarea class="batch-review-editor" [(ngModel)]="reviewTranslationText"></textarea>
                <div class="batch-review-actions">
                  <button class="ssc-btn tiny" type="button" [disabled]="reviewSaving" (click)="updateSelectedTranslationReview('Draft')">Save Draft</button>
                  <button class="ssc-btn tiny" type="button" [disabled]="reviewSaving" (click)="updateSelectedTranslationReview('Needs Review')">Needs Review</button>
                  <button class="ssc-btn tiny" type="button" [disabled]="reviewSaving" (click)="updateSelectedTranslationReview('Rejected')">Reject</button>
                  <button class="ssc-btn primary tiny" type="button" [disabled]="reviewSaving" (click)="updateSelectedTranslationReview('Approved')">Approve</button>
                </div>
                <div class="batch-detail-grid">
                  <div><span>Confidence</span><strong>{{ translation.confidence || '-' }}</strong></div>
                  <div><span>Adequacy</span><strong>{{ translation.adequacy || '-' }}</strong></div>
                  <div><span>Fluency</span><strong>{{ translation.fluency || '-' }}</strong></div>
                  <div><span>Terminology</span><strong>{{ translation.terminology || '-' }}</strong></div>
                  <div><span>Formatting</span><strong>{{ translation.formatting || '-' }}</strong></div>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  }
</app-ssc-shell>
